import './Footer.css';

export default function Footer() {
  return (
    <footer>
      <div className="footer-brand">saqib<span>.</span>ali</div>
      <p className="footer-copy">© 2025 Muhammad Saqib Ali. All rights reserved.</p>
      <div className="footer-links">
        <a href="#home">Home</a>
        <a href="#projects">Projects</a>
        <a href="#contact">Contact</a>
      </div>
    </footer>
  );
}
